import { z } from "zod";

import { DEFAULT_RATE_LIMIT_SETTINGS, RateLimitSettingsSchema } from "../RateLimit.schema";

export const PowerPointDeploymentSettingsSchema = z.object({
  rateLimitSettings: RateLimitSettingsSchema.optional()
});

export type PowerPointDeploymentSettings = z.infer<typeof PowerPointDeploymentSettingsSchema>;

export const DEFAULT_POWERPOINT_SETTINGS: PowerPointDeploymentSettings = {
  rateLimitSettings: DEFAULT_RATE_LIMIT_SETTINGS
};

/** Create PowerPoint Add-in deployment settings with defaults. Accepts unknown (raw Prisma JsonValue). */
export function createPowerPointDeploymentSettings(
  overrides?: unknown
): PowerPointDeploymentSettings {
  if (!overrides || typeof overrides !== "object" || Array.isArray(overrides)) {
    return { ...DEFAULT_POWERPOINT_SETTINGS };
  }
  return { ...DEFAULT_POWERPOINT_SETTINGS, ...overrides } as PowerPointDeploymentSettings;
}
